import { render, staticRenderFns } from "./MessageRow.vue?vue&type=template&id=97959262&scoped=true&"
import script from "./MessageRow.vue?vue&type=script&lang=ts&"
export * from "./MessageRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97959262",
  null
  
)

export default component.exports